import React from 'react';
import PropTypes from 'prop-types';
import {filterNodeProperties} from '../../../../utilities/filter-node-properties';

let classNames = require('classnames');

const getDataFromNode = function(node) {
    const keys = ['id', 'title', 'correct'];
    return filterNodeProperties(node, keys, { val: node.val });
};

class AnswerNode extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...getDataFromNode(props.node),
        };
    }

    render() {
        const {val} = this.state;
        let liClass = classNames({
            'selected-mc-answer': this.props.selected
        });
        return (
            <li type="A" onClick={() => this.props.onClick(this.state.id)} className={liClass}
                dangerouslySetInnerHTML={{__html:val}} />
        );
    }
}

AnswerNode.propTypes = {
    node: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.bool.isRequired
};

export default AnswerNode;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/answer-node.js